import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'tenancy',
    lazy: async () => ({ Component: (await import('./TenancyPage')).TenancyPage }),
  },
];
